/**
 * Topic list with names and keys
 * Contains a comprehensive list of topics with unique identifiers
 * Key ranges: Environment (1-99), Hazardous Materials (100-199), Health & Safety (200-299), Industry Categories (300+)
 */
export interface Topic {
  key: number;
  name: string;
  disabled?: boolean;
}

export const TOPIC_LIST: Topic[] = [
  // Environment Group (1-99)
  { key: 1, name: "Air" },
  { key: 2, name: "Asbestos" },
  { key: 3, name: "Bulk Storage/Transfer/Spill Plans" },
  { key: 4, name: "Coastal Zone" },
  { key: 5, name: "Drinking Water" },
  { key: 6, name: "General & Multimedia" },
  { key: 7, name: "Hazardous Waste" },
  { key: 8, name: "Noise" },
  { key: 9, name: "PCBs" },
  { key: 10, name: "Pesticides" },
  { key: 11, name: "Solid Waste" },
  { key: 12, name: "Wastewater/Stormwater" },
  { key: 13, name: "Water Management/Quality" },
  { key: 14, name: "Wildlife Management" },

  // Hazardous Materials Group (100-199)
  { key: 100, name: "Alcohol, Tobacco and Firearms & Explosives" },
  { key: 101, name: "Chemical Management/Haz Materials" },
  { key: 102, name: "CLP" },
  { key: 103, name: "General Hazardous Materials Transport" },
  { key: 104, name: "Rail Hazardous Materials Transport" },
  { key: 105, name: "Road Hazardous Materials Transport" },
  { key: 106, name: "Major Hazard Facilities" },
  { key: 107, name: "Radioactive Materials" },
  { key: 108, name: "REACH" },
  { key: 109, name: "Spill and Releases" },
  { key: 110, name: "Storage of Dangerous/Hazardous Substances" },
  { key: 111, name: "Explosives" },

  // Health & Safety Group (200-299)
  { key: 200, name: "Codes/Code Compliance", disabled: true },
  { key: 201, name: "Construction H&S" },
  { key: 202, name: "Equipment, Machinery and Electrical Safety" },
  { key: 203, name: "Fire Safety" },
  { key: 204, name: "Industrial Hygiene" },
  { key: 205, name: "Material Handling and In-Plant Safety" },
  { key: 206, name: "Workplace H&S" },

  // Industry Categories Group (300+)
  { key: 300, name: "Food, Drugs and Cosmetics", disabled: true },
  { key: 301, name: "Mining" },
  { key: 302, name: "Oil & Gas/Pipelines" },
  { key: 303, name: "Power Generation" },
];

/**
 * Helper function to get topic name by key
 * @param key - The topic key
 * @returns The topic name or undefined if not found
 */
export function getTopicByKey(key: number): Topic | undefined {
  return TOPIC_LIST.find((topic) => topic.key === key);
}

/**
 * Helper function to get topic key by name
 * @param name - The topic name
 * @returns The topic key or undefined if not found
 */
export function getTopicByName(name: string): Topic | undefined {
  return TOPIC_LIST.find(
    (topic) => topic.name.toLowerCase() === name.toLowerCase(),
  );
}
